import {useMutation} from '@tanstack/react-query';
import {useNavigate} from 'react-router';

import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {useExperimentsApi} from 'apps/experiments/src/api/experiments';
import {getReportUrl} from 'common/report/util';
import {useTranslation} from 'common/i18n/hooks';

import {useExperimentPageContext} from '../context';
import {NEW_EXPERIMENT_PARAMS} from '../utils';
import {ListPageTrackingEvent, trackExperimentListPageAction} from '../tracking';

export function useCreateExperiment() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {projectId, workspaceId} = useExperimentPageContext();

  const {createExperiment} = useExperimentsApi({
    projectId,
    workspaceId,
  });

  const createMutation = useMutation({
    mutationFn: createExperiment,
    onSuccess: (data) => {
      navigate(
        getReportUrl(`experiments/${data.id.toString()}`, {
          projectId,
          workspaceId,
        }),
      );
    },
    onError: () => {
      addToast({
        message: t(`experiments.actions.create.fail`),
        type: ToastType.ERROR,
        timeout: 6000,
      });
    },
    onSettled: (_, error) => {
      trackExperimentListPageAction({
        event: error ? ListPageTrackingEvent.CreateExperimentError : ListPageTrackingEvent.CreateExperiment,
        props: error ? {'error message': error.message} : {},
      });
    },
  });

  const create = () => {
    createMutation.mutate(NEW_EXPERIMENT_PARAMS);
  };

  return create;
}
